import React from "react"

import { Link } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./tag.module.scss"

const Tag = ({ children, active, url, color, light, partner, onClick }) => {
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        onKeyPress={onClick}
        className={`${styles.tag} ${styles.tag__click} ${
          active ? styles.tag__active : ""
        } ${styles[`tag__${color?.replaceAll("-", "")}`]} ${
          light ? styles.tag__light : ""
        } ${partner ? styles.tag__partner : ""}`}
      >
        {children}
      </button>
    )
  }

  if (active || !url) {
    return (
      <div
        className={`${styles.tag} ${styles.tag__noLink} ${
          active ? styles.tag__active : ""
        } ${styles[`tag__${color?.replaceAll("-", "")}`]} ${
          light ? styles.tag__light : ""
        } ${partner ? styles.tag__partner : ""}`}
      >
        {children}
      </div>
    )
  }

  return (
    <Link
      to={url}
      className={`${styles.tag} ${
        styles[`tag__${color?.replaceAll("-", "")}`]
      } ${
        light ? styles.tag__light : ""
      } ${partner ? `${styles.tag__partner} ${styles.tag__partnerLink}` : ""} `}
    >
      {children}
    </Link>
  )
}

export default Tag

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  url: PropTypes.string,
  color: PropTypes.string,
  light: PropTypes.bool,
  partner: PropTypes.bool,
}

Tag.defaultProps = {
  onClick: null,
  active: false,
  url: "",
  color: "",
  light: false,
  partner: false,
}
